import ApplicationController from './application_controller'
import { createPopper } from '@popperjs/core';
import * as bootstrap from 'bootstrap';

/* This is the custom StimulusReflex controller for the Posts Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {

  static targets = ['trigger', 'qrcode']

  connect () {
    if(this.triggerTargets !== undefined) {
      this.triggerTargets.forEach((triggerTarget) => {
        triggerTarget.setAttribute("data-bs-html", true);
        new bootstrap.Popover(triggerTarget);
        triggerTarget.addEventListener('show.bs.popover', this.showOverlay.bind(this));
      });
    }

    this.popper = document.createElement('div');
    this.popper.classList = 'd-none popover bs-popover-auto fade';
    this.popper.classList.add('popover-content');

    this.popperContent = document.createElement('div');
    this.popperContent.classList = 'popover-body';


    this.moveUpButton = document.createElement('button');
    this.moveUpButton.classList = 'btn btn-sm btn-primary mx-1';
    this.moveUpButton.innerHTML = '<i fill="white" class="bi bi-chevron-up"></i>';
    this.moveUpButton.addEventListener('click', this.moveUp.bind(this));

    this.moveDownButton = document.createElement('button');
    this.moveDownButton.classList = 'btn btn-sm btn-primary mx-1';
    this.moveDownButton.innerHTML = '<i fill="white" class="bi bi-chevron-down"></i>';
    this.moveDownButton.addEventListener('click', this.moveDown.bind(this));

    this.moveToTopButton = document.createElement('button');
    this.moveToTopButton.classList = 'btn btn-sm btn-primary mx-1';
    this.moveToTopButton.innerHTML = '<i fill="white" class="bi bi-chevron-double-up"></i>';
    this.moveToTopButton.addEventListener('click', this.moveToTop.bind(this));

    this.moveToBottomButton = document.createElement('button');
    this.moveToBottomButton.classList = 'btn btn-sm btn-primary mx-1';
    this.moveToBottomButton.innerHTML = '<i fill="white" class="bi bi-chevron-double-down"></i>';
    this.moveToBottomButton.addEventListener('click', this.moveToBottom.bind(this));

    this.prioInput = document.createElement('input');
    this.prioInput.classList = 'form-control form-control-sm mx-1 mb-2';
    this.prioInput.type = 'number';
    this.prioInput.min = 1;
    this.prioInput.max = 100;
    this.prioInput.addEventListener('change', this.updatePriority.bind(this));

    this.popperContent.appendChild(this.prioInput);
    this.popperContent.appendChild(this.moveUpButton);
    this.popperContent.appendChild(this.moveDownButton);
    this.popperContent.appendChild(this.moveToTopButton);
    this.popperContent.appendChild(this.moveToBottomButton);

    this.popper.appendChild(this.popperContent);
    document.querySelector('body').insertAdjacentElement('beforeend', this.popper);
    console.log("quick move");
    // Add event listener to window to close popover when clicked outside
    window.addEventListener('click', (event) => {
      // If the popper exists and is shown, and the click is outside the popper
      // and not on the trigger element that opened the popper
      if (
        this.popper &&
        this.popper.classList.contains('show') &&
        !this.popper.contains(event.target) &&
        !event.target.closest('.post-priority')
      ) {
        this.hidePopper();
      }
    });
  }

  handleHover(e) {
    console.log("handleHover")
    // Set a timer for half a second then call showOverlay
    this.hoverTimer = setTimeout(function(){
      console.log("should show overlay");
      this.showOverlay(e);
    }.bind(this), 500);
  }

  showOverlay (e) {
    this.currentPost = e.target.closest('li.post-item');
    this.currentColumn = this.currentPost.closest('ul.posts');
    this.currentPriority = Number(this.currentPost.dataset.priority);
    this.prioInput.max = this.currentColumn.children.length;
    this.prioInput.value = this.currentPriority;

    this.currentPopover = createPopper(e.target, this.popper, {
      placement: 'bottom',
    });
    this.popper.setAttribute('data-show', 'show data');
    this.popper.classList.remove('d-none');
    this.popper.classList.add('show');
    this.currentPopover.update();
    this.currentCardId = e.target.closest('[data-cardid]').dataset.cardid;

  }
  async moveUp() {
    const response = await this.sendPatch("up");
  }
  async moveDown() {
    const response = await this.sendPatch("down");
  }
  async moveToTop() {
    const response = await this.sendPatch("top");
  }
  async moveToBottom() {
    const response = await this.sendPatch("bottom");
  }
  scrollToCurrentPost() {
    if (this.currentPost) {
      this.currentPost.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  async updatePriority() {
    const response = await this.doFetch(
      "/posts/" + this.currentCardId + "/update_priority",
      "PATCH",
      JSON.stringify({
        authenticity_token: this.getCsrfToken(),
        remote: true,
        priority: this.prioInput.value
      }),
    );
    if (response.ok) {
      this.hidePopper();
    }
  }
  async sendPatch(action) {
    const response = await this.doFetch(
      "/posts/" + this.currentCardId + "/" + action,
      "PATCH",
      JSON.stringify({
        authenticity_token: this.getCsrfToken(),
        remote: true,
      }),
    );
    if (response.ok) {
      this.hidePopper();
      this.scrollToCurrentPost();
    }
    return response;
  }
  hidePopper() {
    this.popper.classList.remove('show');
  }
}
